/* eslint-disable react/prop-types */
import { Box, Text } from '@chakra-ui/core'
import { useTranslation } from 'react-i18next'
import React, { FC, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useRecoilValue } from 'recoil'
import { QuantityBox } from '@engyalo/storefront-components'
import { BoxLinkButton } from '../../lib/types'
import { MinAmountProgress } from '../MinAmountProgress'
import { cartStatsState } from '../../recoil/selectors'
import { configState, orderConfigState } from '../../recoil/atoms'
import { getStoreFront_orderConfig as IOrderConfig } from '@engyalo/storefront-types/lib/graphql/storefront'
import { IConfig } from '@engyalo/storefront-types/lib/plugins/model'
import { usePlugin } from '../../Plugin'
import { Hook, IStorefrontSettings } from '@engyalo/storefront-types'
import format from 'number-format.js'
  
export const ButtonTotal: FC = () => {
    const { t } = useTranslation()
    const { customer, order } = useParams()
    const config = useRecoilValue<IConfig>(configState)
    const orderConfig = useRecoilValue<IOrderConfig>(orderConfigState)
    const cartStats = useRecoilValue(cartStatsState)
    const { totalNum, totalPrice } = cartStats
    const [minAmout, setMinAmout] = useState<number | undefined>(undefined)
    const storefrontPlugin = usePlugin(Hook.STOREFRONT)

    let hidePrices: boolean
    if ((storefrontPlugin?.props as IStorefrontSettings)?.hidePrices == undefined) {
      hidePrices = totalPrice <= 0
    } else {
      hidePrices = (storefrontPlugin?.props as IStorefrontSettings)?.hidePrices ?? false
    }

    useEffect(() => {
        const { metadata } = orderConfig
    
        if (metadata) {
          try {
            const jsonMetadata = JSON.parse(metadata)
    
            const { client } = jsonMetadata
            if (client) {
              const { minAmount } = client
              setMinAmout(Number.parseFloat(minAmount))
            }else{
              setMinAmout(config.minAmount)
            }
          } catch {
            setMinAmout(config.minAmount)
          }
        } else {
          setMinAmout(config.minAmount)
        }
      }, [config, orderConfig])
    
    return (
        <>
            {totalNum > 0 && (
            <Box
                zIndex={1}
                paddingY="1.2rem"
                paddingX="0.8rem"
                boxShadow="md"
                backgroundColor="white"
                position="sticky"
                flex="0 0 auto"
                width="100%"
                maxW="42.5rem"
                bottom={0}
            >
                {minAmout ? (
                <MinAmountProgress
                    currencyPrefix={config.currencyPrefix}
                    currentAmount={Number(totalPrice)}
                    minAmount={minAmout}
                />
                ) : null}
                <BoxLinkButton
                to={`/${customer}/${order}/cart`}
                display="flex"
                width="100%"
                paddingY="1.2rem"
                paddingX="1.6rem"
                backgroundColor="primary.500"
                borderColor="transparent"
                fontWeight="500"
                color="white"
                fontFamily="body"
                fontSize="1.1rem"
                borderRadius="0.4rem"
                textDecor="none"
                >
                <QuantityBox size="big" value={totalNum} />
                <Text flex="1" fontSize="lg" alignSelf="center" textAlign="center">
                    {t('catalogue-goToCart')}
                </Text>
                {!hidePrices && (
                    <Text fontSize="lg" alignSelf="center">{`${config.currencyPrefix} ${format(
                    config.currencyFormat,
                    +totalPrice
                    )}`}</Text>
                )}
                </BoxLinkButton>
            </Box>
            )}
        </>
    )
}